import React from 'react';
import LoginFrom from './LoginForm';

export const Login = () => {
    return (
        <div>
            <LoginFrom />
        </div>
    );
};
